import API from '@/api/Residential'
import { i18n } from '@/i18n'

export default Validator => {
  Validator.registerAsync('residentialNumber', function (number, attribute, req, passes) {
    let [project, initialNumber] = attribute.split(',')

    if (!number || number == initialNumber) return passes()
    API.validateNumber({ number, project })
      .then(() => passes())
      .catch(() => passes(false, i18n.t('isTaken', { x: i18n.t('unitNumber') })))
  })
}
